import { c as _c } from "react/compiler-runtime";
import styles from './ModalContent.module.css';
import type { MatchingEventCampaignType } from '../types';
import classNames from 'classnames';
import { getPlatformEventInfoText } from './interpolation';
export type FurtherInfoText = {
  spendenmarathon: string;
  verdopplungsaktion: string;
  example: string;
  wwDefault: string;
  platformEventExceptions: string;
};
function getWWInfoText(campaignType: MatchingEventCampaignType | null | undefined, text: FurtherInfoText) {
  switch (campaignType) {
    case 'SPENDENMARATHON':
      return text.spendenmarathon;
    case 'VERDOPPLUNGSAKTION':
      return text.verdopplungsaktion;
    default:
      return text.wwDefault;
  }
}
function WWFurtherInfo({
  campaignType,
  text
}: {
  campaignType: MatchingEventCampaignType | null | undefined;
  text: FurtherInfoText;
}) {
  const info = getWWInfoText(campaignType, text);
  return <p className={classNames(styles.paragraph, {
    [styles.importantInfo!]: campaignType === 'VERDOPPLUNGSAKTION'
  })}>
      {campaignType === 'SPENDENMARATHON' && <span className={styles.importantInfo}>{text.example}</span>}
      {info}
    </p>;
}
function FurtherInfo(t0) {
  const $ = _c(14);
  const {
    isWW,
    campaignType,
    actor,
    matchingPercentage,
    providedAmountInCents,
    hasOnlyOneProject,
    text,
    locale
  } = t0;
  if (isWW) {
    let t1;
    if ($[0] !== campaignType || $[1] !== text) {
      t1 = <WWFurtherInfo campaignType={campaignType} text={text} />;
      $[0] = campaignType;
      $[1] = text;
      $[2] = t1;
    } else {
      t1 = $[2];
    }
    return t1;
  }
  if (campaignType === "SPENDENMARATHON" || campaignType === "PROPORTIONAL") {
    return null;
  }
  const t1 = actor ?? "";
  let t2;
  if ($[3] !== hasOnlyOneProject || $[4] !== locale || $[5] !== matchingPercentage || $[6] !== providedAmountInCents || $[7] !== t1) {
    t2 = getPlatformEventInfoText({
      actor: t1,
      matchingPercentage,
      providedAmountInCents,
      hasOnlyOneProject
    }, locale);
    $[3] = hasOnlyOneProject;
    $[4] = locale;
    $[5] = matchingPercentage;
    $[6] = providedAmountInCents;
    $[7] = t1;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  let t3;
  if ($[9] !== t2) {
    t3 = <span className={styles.importantInfo}>{t2}</span>;
    $[9] = t2;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  let t4;
  if ($[11] !== t3 || $[12] !== text.platformEventExceptions) {
    t4 = <div className={styles.paragraph}><p>{t3}{text.platformEventExceptions}</p></div>;
    $[11] = t3;
    $[12] = text.platformEventExceptions;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  return t4;
}
export default FurtherInfo;